import styles from './RegistrationTasks.scss';
import { find } from 'lodash';
import DateTime from 'common/components/DateTime/DateTime';

export const RegistrationTasks = ({tasks}) => {
    return (
        <div className={styles.registrationTasksContainer} data-cy="RegistrationTasks">
            <header className={styles.registrationTasksHeader}>
                <span className={styles.registrationTasksIcon}>assignment</span>
                <span className={styles.registrationTasksTitle}>Registration Tasks</span>
            </header>
            <section className={styles.registrationTasksList} data-cy="RegistrationTasks-section">
                { tasks.map((task, i) => <RegistrationTask task={task} key={i} />) }
            </section>
        </div>
    );
};

const stateRanks = [
    'registration_initiated',
    'setting_password',
    'watch_training_video',
    'read_eula',
    'registration_complete',
];

export const RegistrationTask = ({task: {steps, task: {createdAt}}}) => {
    const sortableSteps = [...steps];

    sortableSteps.sort(function (lowerStep, higherStep) {
        const lowerStepRank = stateRanks.indexOf(lowerStep.state.name);
        const higherStepRank = stateRanks.indexOf(higherStep.state.name);

        if (lowerStepRank < higherStepRank){
            return -1;
        }
        if(lowerStepRank > higherStepRank){
            return 1;
        }
        return 0;
    });

    const lastUpdatedStep = find(steps, ['stepStatus', 'current']);
    const completedStep = find(steps, s => ['current', 'done'].includes(s.stepStatus) && ['complete', 'cancelled'].includes(s.state.type));

    const createdAtText = <span>Registration task started at <DateTime value={createdAt} time={true} /></span>;
    const lastUpdatedText = lastUpdatedStep
        ? <span>Registration task last updated at <DateTime value={lastUpdatedStep.updatedAt} time={true} /></span>
        : <span>No current registration step</span>;
    const finishedText = completedStep ?
        <span>Registration task {completedStep.state.type} at <DateTime value={completedStep.updatedAt} time={true} /></span>
        : <span>Registration is not completed</span>;

    return (
        <div className={styles.registrationTask} data-cy="RegistrationTasks-return">
            <div className={styles.registrationTaskData} data-cy="RegistrationTasks-createdAtText">
                {createdAtText}
            </div>
            <div className={styles.registrationTaskData} data-cy="RegistrationTasks-lastUpdatedText">
                {lastUpdatedText}
            </div>
            <div className={styles.registrationTaskData} data-cy="RegistrationTasks-finishedText">
                {finishedText}
            </div>
            <div className={styles.registrationStepsList} data-cy="RegistrationTasks-sortableSteps">
                { sortableSteps.map((step, i) => <RegistrationStep step={step} key={i} />) }
            </div>
        </div>
    );
};

const stepStatusIconMap = {
    pending: 'check_box_outline_blank',
    current: 'check_box_outline_blank',
    done: 'check_box'
};

const registrationStepClass = {
    pending: styles.registrationStepPending,
    current: styles.registrationStepCurrent,
    done: styles.registrationStepDone,
};

export const RegistrationStep = ({step: {stepStatus, updatedAt, state: {displayName}}}) => {

    let timestampText = '';
    switch (stepStatus) {
        case 'done':
            timestampText = <span> was completed at <DateTime value={updatedAt} time={true} /></span>;
            break;
        case 'current':
            timestampText = <span> was started at <DateTime value={updatedAt} time={true} /></span>;
            break;
        default:
            timestampText = <span> is not yet started</span>;
            break;
    }

    return (
        <div className={registrationStepClass[stepStatus] || styles.registrationStep} data-cy="RegistrationTasks-RegistrationStep">
            <span className={styles.registrationStepIcon} data-cy="RegistrationTasks-stepStatus">
                { stepStatusIconMap[stepStatus] }
            </span>
            <span className={styles.registrationStepData} data-cy="RegistrationTasks-timestampText">
                <span className={styles.registrationStepTitle}>{displayName}</span>{timestampText}
            </span>
        </div>
    );
};

export default RegistrationTasks;
